import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Search,
  DeleteForever,
} from "@mui/icons-material";
import "devextreme/data/odata/store";

import { confirmAlert } from "react-confirm-alert"; 
import "react-confirm-alert/src/react-confirm-alert.css"; 
import { Card, Col, Container, Dropdown, Form, Modal, Pagination, Row, Table } from "react-bootstrap";
import * as yup from "yup";

import API, { AxiosInstance, Settings } from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import { useLocation, useParams } from "react-router-dom";
import { TextBox, SelectBox, DateBox } from "devextreme-react";
import FieldSelector from "../../components/customComponents/FieldSelector";
import { useFormik } from "formik";
import Sha256 from "../../utils/sha256";
import logoSignos from "../../assets/SignosFrameworkLogo.png";
import { useToast } from "../../contexts/toast";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { exportToPDF as GeneratePDF } from '../../utils/export-to-pdf';
import { exportToExcel as GenerateXLS } from '../../utils/export-to-excel';
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import CustomModal from "../../components/CustomModal/CustomModal";
import useFavorite from "../../hooks/useFavorite";
import moment from "moment";
import "../../index.css";
import "../../styles/stickyTable.css";


const CustomCloseButton = ({ onClose }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      style={{
        border: "1px solid #b0b0b0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        backgroundColor: isHovered ? "#ff4136" : "",
        cursor: "pointer"
      }}
      className="btn"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClose}
      aria-label="Close"
    >
      <i 
        style={{ 
          fontSize: "20px", 
          color: isHovered ? "#ffffff" : "#b0b0b0",
          transition: "color 0.2s ease"
        }} 
        className="fa-solid fa-xmark"
      ></i>
    </button>
  );
};

export default function Transaction() {
  
  const user = parsedUser();
  const { pathname } = useLocation();
  const params = useParams();
  const { idModule } = useParams();
  const toast = useToast();
  const { handleApiResponse, ErrorModal } = useApiResponseHandler();

  const [recordCount, setRecordCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [generalError, setGeneralError] = useState(null);
  const [open, setOpen] = useState(false);
  const [actionMode, setActionMode] = useState(null);//I=Insert, U= Update = C= Consultar, D= Delete
  const [loading, setLoading] = useState(false);
  // const [isPinned, setIsPinned] = useState(false);
  const checkAudit = localStorage.getItem('AuditInformation')

  const initialModel = {
    section: {},
    data: {
      Columns: [],
      Rows: [],
    },
  }
  const [section, setSection] = useState(null);
  const [fields, setFields] = useState([])
  const [filters, setFilters] = useState([]); 
  const [filterValues, setFilterValues] = useState({}); 
  const [model, setModel] = useState(initialModel);
  const [search, setSearch] = useState(""); 
  const [columnFilters, setColumnFilters] = useState({}); 
  const [openFilterColumn, setOpenFilterColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [RecordsQuantity, setRecordsQuantity] = useState(10);
  const allowedPageSizes = [{ value: 10, text: 10 }, { value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 0, text: "Todos" }];
  const [selectedItem, setSelectedItem] = useState(null);
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite()
  const selectedItemRef = useRef(null);
  const stickyHeaderRef = useRef(null);
  const [stickyHeaderHeight, setStickyHeaderHeight] = useState(0);
  const [sortBy, setSortBy] = useState('Id')
  const [sortByOrder, setSortByOrder] = useState('DESC')
  const [formSize, setFormSize] = useState('md');
  const [tableHeader, setTableHeader] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(true); 
  const [showTable, setShowTable] = useState(false);
  const [isSearching, setIsSearching] = useState(true); // Estado para controlar la visibilidad de los filtros 
  
  
  const [selectedFiles, setSelectedFiles] = useState([]); 
  const [uploadingFiles, setUploadingFiles] = useState(false);
  
  
  const [viewerOpen, setViewerOpen] = useState(false);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  
  
  const openFileViewer = (index) => {
    setCurrentFileIndex(index);
    setViewerOpen(true);
  };

  const closeFileViewer = () => {
    setViewerOpen(false);
  };

  const goToPreviousFile = () => {
    setCurrentFileIndex((prev) => (prev > 0 ? prev - 1 : selectedFiles.length - 1));
  };

  const goToNextFile = () => {
    setCurrentFileIndex((prev) => (prev < selectedFiles.length - 1 ? prev + 1 : 0));
  };

  
  const initializeFilterDefaults = useCallback((filters) => {
    const defaults = {};
    const today = new Date();
    
    filters.forEach(filter => {
      if (filter.DefaultValue) {
        
        let defaultValue = filter.DefaultValue;
        
        
        if (filter.HtmlType === 'date' && typeof defaultValue === 'string') {
          
          if (defaultValue.length === 8 && !defaultValue.includes('-')) {
            const year = defaultValue.substring(0, 4);
            const month = defaultValue.substring(4, 6);
            const day = defaultValue.substring(6, 8);
            defaultValue = `${year}-${month}-${day}`;
          }
        
          else if (defaultValue.includes('-') && defaultValue.length === 10) {
            const parts = defaultValue.split('-');
            if (parts.length === 3 && parts[0].length <= 2) {
              defaultValue = `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
          }
        }
        
        defaults[filter.FieldName] = defaultValue;
      } else if (filter.HtmlType === 'date') {
        // Si el filtro es FechaEntrada o contiene "Inicio" -> primer día del mes
        if (filter.FieldName === 'FechaEntrada' || filter.FieldTitle.includes('Inicio') || filter.FieldName.includes('Ini')) {
          const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
          defaults[filter.FieldName] = firstDay.toISOString().split('T')[0];
        }
        // Si el filtro es FechaSalida o contiene "Fin" -> último día del mes
        else if (filter.FieldName === 'FechaSalida' || filter.FieldTitle.includes('Fin') || filter.FieldName.includes('Fin')) {
          const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          defaults[filter.FieldName] = lastDay.toISOString().split('T')[0];
        }
      } else {
        defaults[filter.FieldName] = '';
      }
    });
    
    return defaults;
  }, []);
  
  // Filter helper functions
  const updateColumnFilter = (fieldName, value) => {
    setColumnFilters(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const clearAllFilters = async () => {
    setSearch("");
    setColumnFilters({});
    setOpenFilterColumn(null);
    setTimeout(async () => {
      await bindDataRemote(true);
      await bindDataCountRemote(true);
    }, 100);
  };

  const toggleFilterDropdown = (fieldName) => {
    setOpenFilterColumn(openFilterColumn === fieldName ? null : fieldName);
  };

  const applyColumnFilter = async () => {
    setOpenFilterColumn(null);
    await bindDataRemote();
    await bindDataCountRemote();
  };

  const clearSingleColumnFilter = async (fieldName) => {
    setColumnFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[fieldName];
      return newFilters;
    });
    setTimeout(async () => {
      await bindDataRemote();
      await bindDataCountRemote();
    }, 100);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openFilterColumn && !event.target.closest('.position-relative')) {
        setOpenFilterColumn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openFilterColumn]);
  
  // END PROPERTIES



  //METHODS
  ///BRING THE DATA FROM THE SERVER FOR MODEL AND RECORDS
  const bindDataRemote = useCallback(async (cleanFilter) => {

    // First start loading the model
    setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Construir objeto de búsqueda con FechaIni y FechaFin
      let searchObject = {};
      
      if (cleanFilter == null) {
        // Prioridad 1: Usar filterValues si están disponibles
        if (Object.keys(filterValues).length > 0) {
          searchObject = { ...filterValues };
          console.log("📅 Usando filterValues para búsqueda:", searchObject);
        } 
        // Prioridad 2: Usar valores por defecto desde tableHeader
        else {
          const firstDayThisYear = moment().startOf('year').format('YYYY-MM-DD'); // 01 de enero este año
          const firstDayNextYear = moment().add(1, 'year').startOf('year').format('YYYY-MM-DD'); // 01 de enero próximo año
          
          // Intentar obtener desde tableHeader DefaultValue
          if (tableHeader && tableHeader.length > 0) {
            const fechaIniField = tableHeader.find(f => f.FieldName === 'FechaIni' || f.FieldName === 'FechaEntrada');
            const FechaFinField = tableHeader.find(f => f.FieldName === 'FechaFin' || f.FieldName === 'FechaFin' || f.FieldName === 'FechaSalida');
            
            if (fechaIniField && fechaIniField.DefaultValue) {
              let fechaIni = fechaIniField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (fechaIni.length === 8 && !fechaIni.includes('-')) {
                fechaIni = `${fechaIni.substring(0, 4)}-${fechaIni.substring(4, 6)}-${fechaIni.substring(6, 8)}`;
              } else if (fechaIni.includes('-') && fechaIni.length === 10) {
                const parts = fechaIni.split('-');
                if (parts[0].length <= 2) {
                  fechaIni = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaIni = fechaIni;
            } else {
              // Si no hay DefaultValue, usar 01 de enero de este año
              searchObject.FechaIni = firstDayThisYear;
            }
            
            if (FechaFinField && FechaFinField.DefaultValue) {
              let FechaFin = FechaFinField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (FechaFin.length === 8 && !FechaFin.includes('-')) {
                FechaFin = `${FechaFin.substring(0, 4)}-${FechaFin.substring(4, 6)}-${FechaFin.substring(6, 8)}`;
              } else if (FechaFin.includes('-') && FechaFin.length === 10) {
                const parts = FechaFin.split('-');
                if (parts[0].length <= 2) {
                  FechaFin = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaFin = FechaFin;
            } else {
              // Si no hay DefaultValue, usar 01 de enero del próximo año
              searchObject.FechaFin = firstDayNextYear;
            }
          } else {
            // Si no hay tableHeader, usar 01 de enero de este año y próximo año
            searchObject.FechaIni = firstDayThisYear;
            searchObject.FechaFin = firstDayNextYear;
          }
        }
      }
      
      // Agregar fechas al query como parámetro Search
      if (Object.keys(searchObject).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(searchObject));
      }
      // Filtros por columna tienen prioridad
      else if (Object.keys(columnFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(columnFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros
        query += "&Search=" + search;
      }
      
      query += `&SortBy=${sortBy}&SortType=${sortByOrder}`;
      let quantity = RecordsQuantity === 0 ? recordCount : RecordsQuantity;
      query = query + `&Quantity=${quantity}&pageNumber=${currentPage}`
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/Records`, query);
      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];

      let recordResult = parsedResults.JSONData || [];
      // let configInfo = recordResult[0].JSONConfig ? recordResult[0].JSONConfig[0] : null;
      let dataFromAPI = recordResult[0] ? (recordResult[0].JSONConfig ? recordResult[0].JSONData : recordResult) : [];
      console.log("✅ Datos cargados:", dataFromAPI.length, "registros");


      //TODO: | Use JSONConfig to show specific fields
      let gridData = null;
      let gridColumns = dataFromAPI && dataFromAPI.length > 0 ? Object.keys(dataFromAPI[0]).filter(x => !x.startsWith("Id")) : null;

      //! If grid data stays null, we use the data from the API

      let titles = ['Audit Information', 'Added by', 'Date Added', 'Modified by', 'Last Modified']

      /*setModel({
        ...model,

        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: gridData || dataFromAPI,
        },
      }); */
      //debugger;
      setModel({
        ...model,
        
        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: dataFromAPI,
        },
      });



    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, search, columnFilters, sortBy, sortByOrder, RecordsQuantity, params.id, idModule, tableHeader, filterValues]);


  useEffect(() => {
    setTableHeader([])
    // NO llamar bindDataRemote aquí - se llamará después de cargar los filtros
    setSelectedItem(null);
  }, [params.id, idModule])

  useEffect(() => {
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      bindDataRemote();
      setSelectedItem(null);
    }
  }, [currentPage])

  const bindDataCountRemote = async (cleanFilter) => {

    // First start loading the model
    //setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Construir objeto de búsqueda con FechaIni y FechaFin
      let searchObject = {};
      
      if (cleanFilter == null) {
        // Prioridad 1: Usar filterValues si están disponibles
        if (Object.keys(filterValues).length > 0) {
          searchObject = { ...filterValues };
          console.log("📅 Usando filterValues para conteo:", searchObject);
        } 
        // Prioridad 2: Usar valores por defecto desde tableHeader
        else {
          const firstDayThisYear = moment().startOf('year').format('YYYY-MM-DD'); // 01 de enero este año
          const firstDayNextYear = moment().add(1, 'year').startOf('year').format('YYYY-MM-DD'); // 01 de enero próximo año
          
          // Intentar obtener desde tableHeader DefaultValue
          if (tableHeader && tableHeader.length > 0) {
            const fechaIniField = tableHeader.find(f => f.FieldName === 'FechaIni' || f.FieldName === 'FechaEntrada');
            const FechaFinField = tableHeader.find(f => f.FieldName === 'FechaFin' || f.FieldName === 'FechaFin' || f.FieldName === 'FechaSalida');
            
            if (fechaIniField && fechaIniField.DefaultValue) {
              let fechaIni = fechaIniField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (fechaIni.length === 8 && !fechaIni.includes('-')) {
                fechaIni = `${fechaIni.substring(0, 4)}-${fechaIni.substring(4, 6)}-${fechaIni.substring(6, 8)}`;
              } else if (fechaIni.includes('-') && fechaIni.length === 10) {
                const parts = fechaIni.split('-');
                if (parts[0].length <= 2) {
                  fechaIni = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaIni = fechaIni;
            } else {
              // Si no hay DefaultValue, usar 01 de enero de este año
              searchObject.FechaIni = firstDayThisYear;
            }
            
            if (FechaFinField && FechaFinField.DefaultValue) {
              let FechaFin = FechaFinField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (FechaFin.length === 8 && !FechaFin.includes('-')) {
                FechaFin = `${FechaFin.substring(0, 4)}-${FechaFin.substring(4, 6)}-${FechaFin.substring(6, 8)}`;
              } else if (FechaFin.includes('-') && FechaFin.length === 10) {
                const parts = FechaFin.split('-');
                if (parts[0].length <= 2) {
                  FechaFin = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaFin = FechaFin;
            } else {
              // Si no hay DefaultValue, usar 01 de enero del próximo año
              searchObject.FechaFin = firstDayNextYear;
            }
          } else {
            // Si no hay tableHeader, usar 01 de enero de este año y próximo año
            searchObject.FechaIni = firstDayThisYear;
            searchObject.FechaFin = firstDayNextYear;
          }
        }
      }
      
      // Agregar fechas al query como parámetro Search
      if (Object.keys(searchObject).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(searchObject));
      }
      // Filtros por columna tienen prioridad
      else if (Object.keys(columnFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(columnFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros
        query += "&Search=" + search;
      }

      query = query + `&Quantity=${RecordsQuantity}&pageNumber=${currentPage}`
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/RecordsCount`, query);


      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];
      setRecordCount(parsedResults.JSONData.Count);
      console.log("Record Count that comes from api ", parsedResults.JSONData.Count)


    } catch (error) {
      console.error(error);
    } finally {
      // setLoading(false);
    }
  };

  const bindDataModelRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Model`, querySections);
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      if (parsedResultsSections && (parsedResultsSections.Error || parsedResultsSections.Logout || parsedResultsSections.Expired)) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      // Verificar si JSONData existe antes de continuar
      if (!parsedResultsSections || !parsedResultsSections.JSONData) {
        console.error("❌ JSONData es null o undefined en bindDataModelRemote");
        return;
      }

      let recordResultSection = parsedResultsSections.JSONData;

      //! If grid data stays null, we use the data from the API

      let titles = ['Informacion de auditoria']
      console.log(recordResultSection)
      setSection(recordResultSection[0]);
      setFields(recordResultSection[0].Fields.filter((item) => !titles.includes(item.FieldTitle)));

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };
  
  useEffect(() => {

  })
  const bindDataHeaderRemote = async (cleanFilter) => {

    console.log("🔄 bindDataHeaderRemote iniciado");
    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      console.log("🔄 Llamando a Header con query:", querySections);
      let requestSections = await API.getAction(`api/${prefix}/Header`, querySections);
      console.log("📋 Header response:", requestSections)
      
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      console.log("📋 Header parsed:", parsedResultsSections)
      
      if (parsedResultsSections && (parsedResultsSections.Error || parsedResultsSections.Logout || parsedResultsSections.Expired)) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      // Verificar si JSONData existe antes de continuar
      if (!parsedResultsSections || !parsedResultsSections.JSONData) {
        console.error("❌ JSONData es null o undefined en bindDataHeaderRemote");
        setLoadingFilters(false);
        return;
      }

      // El JSONData viene directamente como objeto, no como array
      let recordResultSection = parsedResultsSections.JSONData;
      console.log("📋 recordResultSection:", recordResultSection);
      
      setFormSize(recordResultSection.FormSize ?? 'lg');

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      console.log("📋 Fields a cargar:", recordResultSection.Fields);

      setTableHeader(recordResultSection.Fields)
      console.log("✅ TableHeader configurado con", recordResultSection.Fields?.length, "campos");
      
      // Cargar filtros dinámicos si existen
      if (recordResultSection.Filters && recordResultSection.Filters.length > 0) {
        setFilters(recordResultSection.Filters);
        console.log("✅ Filtros cargados:", recordResultSection.Filters);
        
        // Inicializar valores por defecto de los filtros inmediatamente
        const defaultValues = initializeFilterDefaults(recordResultSection.Filters);
        setFilterValues(defaultValues);
        console.log("✅ Filtros inicializados inmediatamente con valores:", defaultValues);
      } else {
        setFilters([]);
        setFilterValues({}); // Filtros vacíos si no hay filtros definidos
        console.log("⚠️ No hay filtros definidos en el modelo");
        // Si no hay filtros, ejecutar bindDataRemote directamente
        setTimeout(async () => {
          await bindDataRemote();
          await bindDataCountRemote();
          setShowTable(true);
        }, 100);
      }
      
      setLoadingFilters(false); // Finalizar carga de filtros

    } catch (error) {
      console.error("❌ Error en bindDataHeaderRemote:", error);
      setLoadingFilters(false);
    } finally {
      //  setLoading(false);
    }
  };

  useEffect(() => { 
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      bindDataRemote();
    }
  }, [checkAudit])

  const bindDataDetailsRemote = async (recordId) => {
    //First load records
    try {
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${recordId}${idModule ? "&IdModule=" + idModule : ""}`;
      let request = await API.getAction(`api/${prefix}/Details`, query);
      let results = request.data[0];

      let parsedResults = JSON.parse(results.JSONData)[0];
      if (parsedResults && (parsedResults.Error || parsedResults.Logout || parsedResults.Expired)) {
        if (handleApiResponse(parsedResults)) {
          return;
        }
      }

      // Verificar si JSONData existe antes de continuar
      if (!parsedResults || !parsedResults.JSONData) {
        console.error("❌ JSONData es null o undefined en bindDataDetailsRemote");
        return;
      }

      let finalResult = parsedResults.JSONData;
      fillFormikObject(finalResult);
      
      // Cargar archivos existentes si hay NovedadesDocumentos
      if (finalResult.NovedadesDocumentos && finalResult.NovedadesDocumentos.length > 0) {
        console.log("📁 Cargando documentos existentes:", finalResult.NovedadesDocumentos);
        
        const existingFiles = finalResult.NovedadesDocumentos.map(doc => {
          // Detectar tipo de archivo por extensión
          const fileName = doc.Documento.toLowerCase();
          const isImage = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(fileName);
          const isPDF = /\.pdf$/i.test(fileName);
          const isVideo = /\.(mp4|webm|mov|avi|mkv)$/i.test(fileName);
          
          return {
            id: doc.Id, // ID del documento en BD
            file: {
              name: doc.Documento,
              size: 0 // No tenemos el tamaño desde el servidor
            },
            comentario: doc.Comentario || '',
            previewUrl: doc.Ruta, // URL del servidor
            isImage,
            isPDF,
            isVideo,
            isExisting: true, // Flag para saber que ya existe en servidor
            isReplacing: false, // Flag para saber si se va a reemplazar
            documentId: doc.Id, // ID para eliminar o actualizar
            originalFileName: doc.Documento, // Nombre original del documento
            guid: doc.GUID
          };
        });
        
        setSelectedFiles(existingFiles);
        console.log("✅ Archivos existentes cargados:", existingFiles.length);
      } else {
        setSelectedFiles([]);
      }
      
      setSelectedItem(null)
    } catch (error) {
      console.error(error)
    }
    //Fill object with new values
  };

  //Open edit/add mode
  const toggleOpen = async (action, reload, itemToUse = null) => {
    setActionMode(action);

    if (action === null) {
      setSelectedItem(null);
      formik.resetForm();
      // Limpiar URLs de preview antes de limpiar archivos (solo los locales)
      selectedFiles.forEach(fileData => {
        if (fileData.previewUrl && !fileData.isExisting) {
          URL.revokeObjectURL(fileData.previewUrl);
        }
      });
      setSelectedFiles([]); // Limpiar archivos al cerrar
    }

    if (action === "I") {
      setSelectedItem(null);
      setSelectedFiles([]); // Limpiar archivos al abrir crear
      
      // Establecer fecha de hoy por defecto en campos de fecha
      setTimeout(() => {
        const today = moment().format('YYYY-MM-DD'); // Formato interno del backend
        if (fields && fields.length > 0) {
          fields.forEach((field) => {
            if (field.HtmlType === 'date' && !field.ReadOnly) {
              formik.setFieldValue(field.FieldName, today);
            }
          });
        }
      }, 100);
    }
    if (action === "U" || action === "C" || action === "D") {
      setOpen(!open);
      
      // Usar itemToUse si se proporciona, de lo contrario usar selectedItem
      const itemGUID = itemToUse ? itemToUse.GUID : selectedItem?.GUID;
      if (itemGUID) {
        await bindDataDetailsRemote(itemGUID);
      }
    }

    if (selectedItemRef.current) {
      selectedItemRef.current.clearSelection();
    }

    setGeneralError(null);
    setOpen(!open);
    if (reload) {
      bindDataRemote();
    }
  };

  // Función helper para mostrar modal de éxito
  const showSuccessModal = (message) => {
    confirmAlert({
      closeOnClickOutside: true,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type="success"
            title="¡Acción Completada!"
            message={message}
            primaryButtonText="Aceptar"
            onPrimaryClick={() => {
              onClose();
            }}
            onClose={onClose}
          />
        );
      }
    });
  };

  //Delete the record
  const deleteConfirm = async (obj) => {
    const mensajeConfirmacion = "¿Confirma que desea eliminar este registro?";
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type="error"
            title="¡Confirmar Acción!"
            message={mensajeConfirmacion}
            icon="fa-trash-can"
            primaryButtonText="Continuar"
            secondaryButtonText="Cancelar"
            onPrimaryClick={async () => {
              // Enviar respuesta "Si" al backend con DialogText y DialogResp
              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=Si`;
              await API.getAction(`api/${prefix}/Delete`, query);
              await bindDataRemote();
              setSelectedItem(null);
              
              showSuccessModal("Registro eliminado correctamente!");
            }}
            onSecondaryClick={async () => {
              // Enviar respuesta "No" al backend con DialogText y DialogResp
              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=No`;
              await API.getAction(`api/${prefix}/Delete`, query);
            }}
            onClose={onClose}
          />
        );
      }
    });
  };

  // Función para imprimir/reportar (ejecutar y mostrar PDF)
  const handlePrintReport = async (item) => {
    try {
      console.log("🖨️ Iniciando impresión para item:", item);
      console.log("🔍 Campos disponibles en item:", Object.keys(item));
      
      // Preparar los parámetros del query
      const queryParams = new URLSearchParams({
        Token: user.Token,
        IdUser: user.IdUser.toString(),
        Accion: "R"
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/CRUDeasNovedades?${queryParams.toString()}`;
      
      console.log("🔗 URL de impresión:", url);
      
      // Hacer la petición POST para obtener el HTML
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al obtener el reporte: ${response.status}`);
      }
      
      // Parsear el JSON de respuesta
      const jsonResponse = await response.json();
      console.log("✅ JSON Response completo:", jsonResponse);
      console.log("✅ Tipo de jsonResponse:", typeof jsonResponse);
      console.log("✅ Es array?:", Array.isArray(jsonResponse));
      
      // Función recursiva para buscar HtmlText en cualquier nivel
      const findHtmlText = (obj, path = '') => {
        if (!obj || typeof obj !== 'object') return null;
        
        // Si el objeto actual tiene HtmlText, devolverlo
        if (obj.HtmlText) {
          console.log(`✅ HtmlText encontrado en: ${path || 'raíz'}`);
          return obj.HtmlText;
        }
        
        // Si es un array, buscar en el primer elemento
        if (Array.isArray(obj) && obj.length > 0) {
          return findHtmlText(obj[0], `${path}[0]`);
        }
        
        // Buscar en propiedades comunes primero (optimización)
        const commonPaths = ['ReportData', 'JSONData', 'Data'];
        for (const key of commonPaths) {
          if (obj[key]) {
            const result = findHtmlText(obj[key], `${path}.${key}`);
            if (result) return result;
          }
        }
        
        // Buscar en todas las demás propiedades
        for (const key in obj) {
          if (!commonPaths.includes(key) && obj.hasOwnProperty(key)) {
            const result = findHtmlText(obj[key], `${path}.${key}`);
            if (result) return result;
          }
        }
        
        return null;
      };
      
      // Extraer el HTML usando la búsqueda recursiva
      let htmlContent = '';
      
      // Intentar parsear JSONData si existe (caso común)
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0 && jsonResponse[0].JSONData) {
        try {
          const firstItem = jsonResponse[0];
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          console.log("📊 Parsed JSONData:", parsedData);
          htmlContent = findHtmlText(parsedData, 'JSONData');
        } catch (e) {
          console.warn("⚠️ Error al parsear JSONData:", e);
        }
      }
      
      // Si no se encontró, buscar en toda la respuesta
      if (!htmlContent) {
        htmlContent = findHtmlText(jsonResponse, 'root');
      }
      
      if (!htmlContent) {
        console.error("❌ No se encontró HtmlText en ningún nivel de la respuesta");
        console.error("❌ Estructura completa de la respuesta:", JSON.stringify(jsonResponse, null, 2));
        throw new Error("No se encontró contenido HTML en la respuesta del servidor");
      }
      
      // Limpiar el HTML: eliminar TODOS los escapes
      htmlContent = htmlContent
        .replace(/\\r\\n/g, '\n')      // Reemplazar \r\n escapados con saltos de línea reales
        .replace(/\\r/g, '\r')          // Reemplazar \r escapados
        .replace(/\\n/g, '\n')         // Reemplazar \n escapados
        .replace(/\\t/g, '\t')         // Reemplazar \t escapados
        .replace(/\\"/g, '"')          // Reemplazar \" con "
        .replace(/\\'/g, "'")          // Reemplazar \' con '
        .replace(/\\\//g, '/')         // Reemplazar \/ con /
        .replace(/\\\\/g, '\\')        // Reemplazar \\ con \
        .trim();                       // Eliminar espacios al inicio y final
      
      console.log("📄 HTML después de limpieza:");
      console.log(htmlContent.substring(0, 500)); // Ver primeros 500 caracteres
      
      // Modificar @page para establecer márgenes en 0 (None)
      if (htmlContent.includes('@page')) {
        htmlContent = htmlContent.replace(
          /@page\s*{\s*margin:\s*[^;]+;/g,
          '@page { margin: 0;'
        );
      } else {
        // Si no existe @page, agregarlo antes del cierre de </style>
        htmlContent = htmlContent.replace(
          '</style>',
          '@page { margin: 0; }\n  </style>'
        );
      }
      
      console.log("✅ HTML limpiado y configurado, longitud:", htmlContent.length);
      
      // Crear un iframe temporal oculto
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);
      
      // Escribir el contenido en el iframe
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
      
      // Esperar a que se cargue completamente y luego activar impresión
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          
          // Eliminar el iframe después de imprimir
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 100);
        }, 250);
      };
      
      console.log("✅ Reporte listo para imprimir usando iframe");
      
    } catch (error) {
      console.error("❌ Error al imprimir:", error);
      toast({
        type: "error",
        message: `Error al generar el reporte: ${error.message}`
      });
    }
  };

  //Update the field value on formik according to what has been updated
  const updateField = (fieldName, fieldValue) => {
    // Campos que deben estar en mayúsculas
    const upperCaseFields = ['Descripcion', 'Comentario'];
    
    // Si el campo está en la lista de mayúsculas, convertir el valor
    if (upperCaseFields.includes(fieldName) && typeof fieldValue === 'string') {
      formik.setFieldValue(fieldName, fieldValue.toUpperCase());
    } else {
      formik.setFieldValue(fieldName, fieldValue);
    }
  };

  // Función para subir archivos de la novedad
  const uploadNovedadFiles = async (idNovedad, guidNovedad) => {
    try {
      setUploadingFiles(true);
      
      // Filtrar solo archivos nuevos (no existentes)
      const newFiles = selectedFiles.filter(f => !f.isExisting);
      
      if (newFiles.length === 0) {
        console.log("📁 No hay archivos nuevos para subir");
        return true;
      }
      
      console.log(`📁 Subiendo ${newFiles.length} archivo(s) nuevos para IdNovedad: ${idNovedad}, GUID: ${guidNovedad}`);
      
      // Subir cada archivo individualmente
      for (let i = 0; i < newFiles.length; i++) {
        const fileData = newFiles[i];
        console.log(`📤 Subiendo archivo ${i + 1}/${newFiles.length}:`, fileData.file.name);
        
        // Crear FormData
        const formData = new FormData();
        formData.append('Token', user.Token);
        formData.append('IdUser', user.IdUser);
        formData.append('IdNovedad', idNovedad);
        formData.append('GUIDNovedad', guidNovedad); // Agregar GUID
        formData.append('Files', fileData.file);
        formData.append('Comentario', fileData.comentario || '');
        
        console.log(`📤 FormData enviado - IdNovedad: ${idNovedad}, GUIDNovedad: ${guidNovedad}`);
        
        // Hacer la petición POST con multipart/form-data
        const response = await AxiosInstance.post(
          'api/OcupacionProcesos/NovedadesDocumentosFiles',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        
        console.log(`✅ Archivo ${i + 1} subido:`, response.data);
      }
      
      console.log("✅ Todos los archivos nuevos subidos exitosamente");
      return true;
      
    } catch (error) {
      console.error("❌ Error al subir archivos:", error);
      toast({
        type: "error",
        message: "Error al subir algunos archivos"
      });
      return false;
    } finally {
      setUploadingFiles(false);
    }
  };


  // Función para actualizar/reemplazar archivos existentes
  const updateNovedadFiles = async (idNovedad, guidNovedad) => {
    try {
      setUploadingFiles(true);
      
      // Filtrar solo archivos marcados para actualizar (isReplacing = true)
      const filesToUpdate = selectedFiles.filter(f => f.isReplacing && f.isExisting);
      
      if (filesToUpdate.length === 0) {
        console.log("📁 No hay archivos para actualizar");
        return true;
      }
      
      console.log(`📁 Actualizando ${filesToUpdate.length} archivo(s) para IdNovedad: ${idNovedad}, GUID: ${guidNovedad}`);
      
      // Actualizar cada archivo individualmente
      for (let i = 0; i < filesToUpdate.length; i++) {
        const fileData = filesToUpdate[i];
        console.log(`🔄 Actualizando archivo ${i + 1}/${filesToUpdate.length}:`, fileData.originalFileName);
        
        // Crear FormData
        const formData = new FormData();
        formData.append('Token', user.Token);
        formData.append('IdUser', user.IdUser);
        formData.append('IdNovedad', idNovedad);
        formData.append('Files', fileData.newFile); 
        formData.append('id', fileData.documentId); 
        formData.append('GUIDNovedad', guidNovedad);
        formData.append('Documento', fileData.originalFileName); // Nombre del documento original
        formData.append('Comentario', fileData.comentario || '');
        
        console.log(`🔄 FormData enviado - id: ${fileData.documentId}, Documento: ${fileData.originalFileName}`);
        
        // Hacer la petición PUT con multipart/form-data
        const response = await AxiosInstance.put(
          'api/OcupacionProcesos/NovedadesDocumentosFilesUpd',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        
        console.log(`✅ Archivo ${i + 1} actualizado:`, response.data);
      }
      
      console.log("✅ Todos los archivos actualizados exitosamente");
      return true;
      
    } catch (error) {
      console.error("❌ Error al actualizar archivos:", error);
      toast({
        type: "error",
        message: "Error al actualizar algunos archivos"
      });
      return false;
    } finally {
      setUploadingFiles(false);
    }
  };

  // Función para actualizar SOLO comentarios de archivos existentes (sin reemplazar el archivo)
  const updateNovedadComments = async (idNovedad, guidNovedad) => {
    try {
      // Filtrar archivos existentes que NO están siendo reemplazados
      const filesToUpdateComments = selectedFiles.filter(f => f.isExisting && !f.isReplacing);
      
      if (filesToUpdateComments.length === 0) {
        console.log("💬 No hay comentarios para actualizar");
        return true;
      }
      
      console.log(`💬 Actualizando comentarios de ${filesToUpdateComments.length} archivo(s) para IdNovedad: ${idNovedad}, GUID: ${guidNovedad}`);
      
      // Actualizar comentario de cada archivo individualmente
      for (let i = 0; i < filesToUpdateComments.length; i++) {
        const fileData = filesToUpdateComments[i];
        console.log(`💬 Actualizando comentario ${i + 1}/${filesToUpdateComments.length}:`, fileData.originalFileName || fileData.file.name);
        
        // Crear FormData (sin archivo, solo comentario)
        const formData = new FormData();
        formData.append('Token', user.Token);
        formData.append('IdUser', user.IdUser);
        formData.append('IdNovedad', idNovedad);
        formData.append('id', fileData.documentId); // ID del documento a actualizar
        formData.append('GUIDNovedad', guidNovedad);
        formData.append('Documento', fileData.originalFileName || fileData.file.name); // Nombre del documento original
        formData.append('Comentario', fileData.comentario || '');
        
        // Crear un blob vacío para el campo Files (requerido por el backend)
        const emptyBlob = new Blob([''], { type: 'text/plain' });
        formData.append('Files', emptyBlob, fileData.originalFileName || fileData.file.name);
        
        console.log(`💬 FormData enviado - id: ${fileData.documentId}, Comentario: "${fileData.comentario}"`);
        
        // Hacer la petición PUT con multipart/form-data
        const response = await AxiosInstance.put(
          'api/OcupacionProcesos/NovedadesDocumentosFilesUpd',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        
        console.log(`✅ Comentario ${i + 1} actualizado:`, response.data);
      }
      
      console.log("✅ Todos los comentarios actualizados exitosamente");
      return true;
      
    } catch (error) {
      console.error("❌ Error al actualizar comentarios:", error);
      toast({
        type: "error",
        message: "Error al actualizar algunos comentarios"
      });
      return false;
    }
  };


  const [validationsSchema, setValidationSchema] = useState(null);
  // NUEVO: State para initialValues de Formik (no mutar formik.initialValues directamente)
  const [formikInitialValues, setFormikInitialValues] = useState({});

  const fillFormikObject = (record) => {
    //debugger;
    console.log("record", record, "model", section);
    if (
      section &&
      fields &&
      fields.length > 0
    ) {
      fields.forEach((item) => {
        console.log(
          "field name",
          item.FieldName,
          "RecordValue ",
          record[item.FieldName]
        );
        
        // MODIFICADO: Si record[field] es null y el campo es Required, setear '' para que el formulario no cargue null
        let fieldValue = record[item.FieldName];
        if ((fieldValue === null || fieldValue === undefined || fieldValue === '') && item.Required) {
          fieldValue = item.DefaultValue || '';
        }
        
        formik.setFieldValue(item.FieldName, fieldValue);
      });
    }

    //Now
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section)
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        // MODIFICADO: La validación ya respeta item.Required del backend
        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    
    // MODIFICADO: No mutar formik.initialValues directamente, usar state
    setFormikInitialValues(initialObject);

    console.log("initialObject", initialObject)

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  // NUEVO: Helper para construir valores del SP considerando Required y tipos
  const buildSPValue = (item, objValue) => {
    const value = objValue;
    const isEmptyValue = value === undefined || value === null || value === '';
    
    // Para tipos numéricos y booleanos
    if (
      item.FieldType === "int" ||
      item.FieldType === "bool" ||
      item.FieldType === "bit" ||
      item.FieldType === "bigint"
    ) {
      if (isEmptyValue) {
        if (item.DefaultValue && item.DefaultValue.length > 0) {
          return item.DefaultValue;
        }
        // Si es requerido y no tiene DefaultValue, enviar '0'
        return item.Required ? "'0'" : "null";
      }
      return "'" + value + "'";
    } 
    // Para passwords
    else if (item.HtmlType === "password") {
      if (isEmptyValue) {
        // Si es requerido y vacío, enviar cadena vacía
        return item.Required ? "''" : "null";
      }
      // Nota: obj completo no está disponible aquí, usar valor directo
      let passwordEncrypted = null;
      if (value && value.length > 0) {
        passwordEncrypted = value;
        passwordEncrypted = Sha256.hash(passwordEncrypted);
      }
      return passwordEncrypted ? "'" + passwordEncrypted + "'" : (item.Required ? "''" : "null");
    } 
    // Para radio buttons
    else if (item.HtmlType === 'radio') {
      if (isEmptyValue) {
        if (item.DefaultValue && item.DefaultValue.length > 0) {
          return "'" + item.DefaultValue + "'";
        }
        return item.Required ? "''" : "null";
      }
      return "'" + value + "'";
    } 
    // Para strings y otros tipos
    else {
      if (isEmptyValue) {
        if (item.DefaultValue && item.DefaultValue.length > 0) {
          return "'" + item.DefaultValue + "'";
        }
        // Si es requerido y vacío, enviar cadena vacía
        return item.Required ? "''" : "null";
      }
      // Escapar comillas simples: reemplazar ' por ''
      const escapedValue = String(value).replace(/'/g, "''");
      return "'" + escapedValue + "'";
    }
  };

  //This method is to save the record we are working on
  const handleSubmit = async (obj, event) => {
    console.log("❗ ~ file: CRUDSimple.js:259 ~ handleSubmit ~ obj:", obj)
    console.log({ fields: fields })
    
    // ✅ Validación dinámica de campos Required
    const erroresValidacion = [];

    (fields || []).forEach((f) => {
      if (!f?.Required) return;

      const value = obj?.[f.FieldName];

      const isEmptyString = typeof value === "string" && value.trim() === "";
      const isNullish = value === null || value === undefined;
      const isEmptyArray = Array.isArray(value) && value.length === 0;

      const isEmpty =
        isNullish ||
        isEmptyString ||
        isEmptyArray;

      if (isEmpty) {
        const label = f.FieldTitle || f.FieldName;
        erroresValidacion.push(`El campo '${label}' es obligatorio`);
      }
    });

    if (erroresValidacion.length > 0) {
      toast({
        type: "error",
        message: (
          <div style={{ textAlign: "left" }}>
            {erroresValidacion.map((error, index) => (
              <div key={index}>• {error}</div>
            ))}
          </div>
        ),
      });
      return;
    }
    
    let actions = {
      "I": "I",
      "U": "U",
      "D": "I"
    };

    if (actionMode === "D") {
      const { GUID, Id, ...rest } = obj;
      obj = rest;
    }

    // Determinar mensaje y tipo según el modo de acción
    const mensajeConfirmacion = actionMode === "U" 
      ? "¿Confirma que desea guardar los cambios a esta novedad?"
      : "¿Confirma que desea guardar esta novedad?";
    
    const tipoModal = actionMode === "U" ? "warning" : "confirm";
    
    console.log("🔍 Modal de confirmación - actionMode:", actionMode, "tipoModal:", tipoModal, "mensaje:", mensajeConfirmacion);
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type={tipoModal}
            title="¡Confirmar Acción!"
            message={mensajeConfirmacion}
            primaryButtonText="Confirmar"
            secondaryButtonText="Cancelar"
            onPrimaryClick={async () => {
              // Enviar respuesta "Si" al backend con DialogText y DialogResp
              let objSPVersion = "";
              fields.forEach((item) => {
                if (item.ReadOnly || item.HtmlType === "separator") return;

                if (item.HtmlType !== "separator") {
                  objSPVersion +=
                    (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
                }
                
                // MODIFICADO: Manejar password especialmente para incluir UserName
                if (item.HtmlType === "password") {
                  const value = obj[item.FieldName];
                  const isEmptyValue = value === undefined || value === null || value === '';
                  
                  if (isEmptyValue) {
                    objSPVersion += item.Required ? "''" : "null";
                  } else {
                    let passwordEncrypted = null;
                    if (value && value.length > 0) {
                      passwordEncrypted = obj["UserName"] ? obj["UserName"].toUpperCase() + value : value;
                      passwordEncrypted = Sha256.hash(passwordEncrypted);
                    }
                    objSPVersion += passwordEncrypted ? "'" + passwordEncrypted + "'" : (item.Required ? "''" : "null");
                  }
                } else {
                  // MODIFICADO: Usar helper buildSPValue que respeta Required
                  objSPVersion += buildSPValue(item, obj[item.FieldName]);
                }
              });

              let queryString = `IdUser=${user.IdUser}&Id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=Si`;
              let queryData = {
                Data: objSPVersion,
              };

              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              let request = await API.postAction(
                `api/${prefix}/AddEdit?${queryString}`,
                queryData
              );

              if (request.status === 200) {
                let response = JSON.parse(request.data[0].JSONData)[0];
                if (response.Error) {
                  setGeneralError(response.Msg);
                  return;
                }
                
                console.log("📋 Response completo del servidor:", response);
                
                // Extraer el ID y GUID de la novedad (creada o actualizada) desde la respuesta
                let idNovedad = null;
                let guidNovedad = null;
                
                // En modo Update, usar el ID y GUID del objeto que viene del formulario
                if (actionMode === "U") {
                  // Prioridad: obj (formik) > selectedItem > response
                  idNovedad = obj.Id || selectedItem?.Id || response.JSONData?.Id || response.Id || null;
                  // IMPORTANTE: También buscar "guid" en minúscula
                  guidNovedad = obj.GUID || obj.guid || 
                                selectedItem?.GUID || selectedItem?.guid || 
                                response.JSONData?.GUID || response.JSONData?.Guid || response.JSONData?.guid ||
                                response.GUID || response.Guid || response.guid || 
                                null;
                  console.log("📋 Modo Update - usando obj/selectedItem:", { 
                    idNovedad, 
                    guidNovedad,
                    fromObj: { Id: obj.Id, GUID: obj.GUID },
                    fromSelectedItem: { Id: selectedItem?.Id, GUID: selectedItem?.GUID }
                  });
                } 
                // En modo Insert, obtener el ID y GUID desde la respuesta
                else {
                  // Parsear JSONData si viene como string
                  let parsedData = response.JSONData;
                  if (typeof parsedData === 'string') {
                    try {
                      parsedData = JSON.parse(parsedData);
                      console.log("  - JSONData parseado:", parsedData);
                    } catch (e) {
                      console.warn("  ❌ No se pudo parsear JSONData:", e);
                    }
                  }
                  
                  // Intentar múltiples formas de obtener el ID
                  idNovedad = parsedData?.Id || 
                              parsedData?.[0]?.Id || 
                              response.Id || 
                              response.IdNovedad ||
                              null;
                  
                  // IMPORTANTE: El backend devuelve "guid" en minúscula
                  guidNovedad = parsedData?.GUID || 
                                parsedData?.[0]?.GUID ||
                                parsedData?.Guid ||
                                parsedData?.[0]?.Guid ||
                                parsedData?.guid ||  // ← AGREGADO: minúscula
                                parsedData?.[0]?.guid ||  // ← AGREGADO: minúscula
                                response.GUID || 
                                response.GUIDNovedad ||
                                response.Guid ||
                                response.guid ||  // ← AGREGADO: minúscula
                                null;
                  
                  console.log("📋 Modo Insert - desde response:", { 
                    idNovedad, 
                    guidNovedad,
                    parsedData,
                    responseComplete: response,
                    "idNovedad existe?": !!idNovedad,
                    "guidNovedad existe?": !!guidNovedad
                  });
                }
                
                console.log(`✅ ${actionMode === "U" ? "Novedad actualizada" : "Novedad creada"} con ID:`, idNovedad, "GUID:", guidNovedad);
                
                // Debug: Verificar el estado de selectedFiles antes de filtrar
                console.log("🔍 selectedFiles ANTES de filtrar:", selectedFiles.map(f => ({
                  name: f.file?.name,
                  isExisting: f.isExisting,
                  isReplacing: f.isReplacing,
                  documentId: f.documentId
                })));
                
                // Filtrar archivos nuevos y archivos para actualizar
                const newFilesToUpload = selectedFiles.filter(f => !f.isExisting && !f.isReplacing);
                const filesToUpdate = selectedFiles.filter(f => f.isReplacing && f.isExisting);
                
                console.log("📊 Estado de archivos:", {
                  totalFiles: selectedFiles.length,
                  newFiles: newFilesToUpload.length,
                  filesToUpdate: filesToUpdate.length,
                  selectedFiles: selectedFiles.map(f => ({
                    name: f.file.name,
                    isExisting: f.isExisting,
                    isReplacing: f.isReplacing
                  }))
                });
                
                // Subir archivos nuevos si hay alguno seleccionado
                if (newFilesToUpload.length > 0 && idNovedad && guidNovedad) {
                  console.log(`📁 Subiendo ${newFilesToUpload.length} archivo(s) nuevo(s)...`);
                  await uploadNovedadFiles(idNovedad, guidNovedad);
                } else {
                  console.log("⏭️ Sin archivos nuevos para subir", { 
                    hasFiles: newFilesToUpload.length > 0, 
                    hasId: !!idNovedad, 
                    hasGuid: !!guidNovedad 
                  });
                }
                
                // Actualizar archivos existentes si hay alguno marcado para reemplazar
                if (filesToUpdate.length > 0 && idNovedad && guidNovedad) {
                  console.log(`🔄 Actualizando ${filesToUpdate.length} archivo(s) existente(s)...`);
                  await updateNovedadFiles(idNovedad, guidNovedad);
                } else {
                  console.log("⏭️ Sin archivos para actualizar", { 
                    hasFiles: filesToUpdate.length > 0, 
                    hasId: !!idNovedad, 
                    hasGuid: !!guidNovedad 
                  });
                }
                
                // Actualizar comentarios de archivos existentes (sin reemplazar)
                if (idNovedad && guidNovedad) {
                  console.log(`💬 Verificando comentarios de archivos existentes...`);
                  await updateNovedadComments(idNovedad, guidNovedad);
                }
                
                // Contar archivos nuevos y actualizados
                const newFilesCount = selectedFiles.filter(f => !f.isExisting && !f.isReplacing).length;
                const updatedFilesCount = selectedFiles.filter(f => f.isReplacing && f.isExisting).length;
                
                // Construir mensaje según los archivos procesados
                let message = "¡Registro guardado correctamente!";
                if (newFilesCount > 0 && updatedFilesCount > 0) {
                  message = `¡Registro guardado, ${newFilesCount} ${newFilesCount === 1 ? 'archivo nuevo subido' : 'archivos nuevos subidos'} y ${updatedFilesCount} ${updatedFilesCount === 1 ? 'archivo actualizado' : 'archivos actualizados'} exitosamente!`;
                } else if (newFilesCount > 0) {
                  message = `¡Registro guardado y ${newFilesCount} ${newFilesCount === 1 ? 'archivo nuevo subido' : 'archivos nuevos subidos'} exitosamente!`;
                } else if (updatedFilesCount > 0) {
                  message = `¡Registro guardado y ${updatedFilesCount} ${updatedFilesCount === 1 ? 'archivo actualizado' : 'archivos actualizados'} exitosamente!`;
                }
                
                showSuccessModal(message);
                
                // Limpiar archivos
                setSelectedFiles([]);
              }

              setGeneralError(null);
              setSelectedItem(null);

              formik.resetForm();
              
              toggleOpen(null, true);
            }}
            onSecondaryClick={async () => {
              // Enviar respuesta "No" al backend con DialogText y DialogResp
              // Preparar los datos para enviar
              let objSPVersion = "";
              fields.forEach((item) => {
                if (item.ReadOnly || item.HtmlType === "separator") return;

                if (item.HtmlType !== "separator") {
                  objSPVersion +=
                    (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
                }
                
                // MODIFICADO: Manejar password especialmente para incluir UserName
                if (item.HtmlType === "password") {
                  const value = obj[item.FieldName];
                  const isEmptyValue = value === undefined || value === null || value === '';
                  
                  if (isEmptyValue) {
                    objSPVersion += item.Required ? "''" : "null";
                  } else {
                    let passwordEncrypted = null;
                    if (value && value.length > 0) {
                      passwordEncrypted = obj["UserName"] ? obj["UserName"].toUpperCase() + value : value;
                      passwordEncrypted = Sha256.hash(passwordEncrypted);
                    }
                    objSPVersion += passwordEncrypted ? "'" + passwordEncrypted + "'" : (item.Required ? "''" : "null");
                  }
                } else {
                  // MODIFICADO: Usar helper buildSPValue que respeta Required
                  objSPVersion += buildSPValue(item, obj[item.FieldName]);
                }
              });

              let queryString = `IdUser=${user.IdUser}&Id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=No`;
              let queryData = {
                Data: objSPVersion,
              };

              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              await API.postAction(
                `api/${prefix}/AddEdit?${queryString}`,
                queryData
              );
            }}
            onClose={onClose}
          />
        );
      }
    });


  };

  const formik = useFormik({
    initialValues: formikInitialValues, // MODIFICADO: usar el state en lugar de {}
    enableReinitialize: true,

    validateOnChange: false,
    validateOnBlur: false,

    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });

  const addFavorite = async () => {

    const newFavorite = {
      icon: `${section.FormIcon}`,
      path: pathname,
      formPath: section.FormPath,
      title: section.FormTitle,
    }
    UpdateFavorites(newFavorite)

  }

  const headerWithoutAuditFields = () => {
    const headers = tableHeader && tableHeader
      .filter(x =>
        x.FieldTitle !== "Audit Information"
        && x.FieldName !== "Id"
        && x.FieldName !== "IdUserAdd"
        && x.FieldName !== 'DateAdd'
        && x.FieldName !== 'IdUserMod'
        && x.FieldName !== 'DateMod'
        
      
      )
    console.log("📋 headerWithoutAuditFields:", headers?.length, "campos visibles");
    return headers;
  }

  // Modified by Frandy para exportar solo las columnas visibles
  const exportToExcel = useCallback(async () => {

    const visibleColumns = headerWithoutAuditFields();
    
    const excelData = model.data.Rows && model.data.Rows.map((item) => {
      return visibleColumns.reduce((acc, column) => {
        acc[column.FieldName] = item[column.FieldName];
        return acc;
      }, {});

    });
  
    GenerateXLS(excelData, `${section.FormTitle}.xlsx`);

  }, [model.data.Rows, tableHeader, section]);

  const exportToPDF = useCallback(async () => {
    const container = document.getElementById("contentContainer");
    if (container) {
      await GeneratePDF(container, "landscape", section?.FormTitle || "Registro");
    } else {
      console.error("No se encontró el contenedor para exportar a PDF");
      alert("Error: No se puede exportar el contenido. Elemento no encontrado.");
    }
    // GeneratePDF(container);
  }, [section])

  // Add by Victor: Agrega el handlePrint para imprimir el contenido de la pantalla
  const handlePrint = useCallback(() => {
    // Crear el HTML de la tabla
    const visibleColumns = headerWithoutAuditFields();
    
    const tableHTML = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${section?.FormTitle || 'Tabla'}</title>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
          <style>
            @media print {
              @page {
                margin: 1cm;
                size: landscape;
              }
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            h4 {
              text-align: center;
              font-weight: bold;
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
            }
            th {
              background-color: #6c757d;
              color: white;
              font-weight: bold;
              padding: 8px;
              border: 1px solid #000;
              text-align: left;
            }
            td {
              padding: 8px;
              border: 1px solid #000;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
            .icon-container {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 10px;
            }
            .icon-item {
              font-size: 1.2rem;
            }
          </style>
        </head>
        <body>
          <h4>${section?.FormTitle || 'Tabla'}</h4>
          <table>
            <thead>
              <tr>
                ${visibleColumns.map(column => `<th>${column.FieldTitle}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${model?.data?.Rows?.map((item) => {
                return `<tr>
                  ${visibleColumns.map((column) => {
                    const rawValue = item[column.FieldName];
                    
                    // Detectar y renderizar iconos en formato JSON
                    let parsedIcons = null;
                    if (typeof rawValue === 'string' && (rawValue.trim().startsWith('[') || rawValue.trim().startsWith('{'))) {
                      try {
                        // Limpiar el JSON: eliminar comas antes de ] o }
                        let cleanedJson = rawValue
                          .replace(/,(\s*[\]}])/g, '$1')
                          .replace(/\r\n/g, '')
                          .replace(/\n/g, '');
                        
                        parsedIcons = JSON.parse(cleanedJson);
                      } catch (e) {
                        // Si falla el parseo, continuar con el flujo normal
                      }
                    }
                    
                    // Si es un array de iconos
                    if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                      const iconsHtml = parsedIcons.map(iconObj => {
                        const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                        const opacity = isDisabled ? 0.3 : 1;
                        const color = isDisabled ? '#ccc' : '#000';
                        return '<span class="icon-item" title="' + (iconObj.Name || iconObj.function) + '" style="opacity: ' + opacity + '; color: ' + color + ';"><i class="' + iconObj.icon + '"></i></span>';
                      }).join('');
                      return '<td><div class="icon-container">' + iconsHtml + '</div></td>';
                    }
                    
                    // Renderizado normal
                    let cellValue = '';
                    if (column.FieldType === "datetime" || column.FieldType === "date") {
                      cellValue = moment(item[column.FieldName]).format("MM/DD/YYYY");
                    } else if (typeof item[column.FieldName] === 'boolean') {
                      cellValue = item[column.FieldName] ? 'Sí' : 'No';
                    } else {
                      cellValue = item[column.FieldName] || '';
                    }
                    return '<td>' + cellValue + '</td>';
                  }).join('')}
                </tr>`;
              }).join('') || ''}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Crear un iframe temporal oculto
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);
    
    // Escribir el contenido en el iframe
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(tableHTML);
    iframeDoc.close();
    
    // Esperar a que se cargue y luego imprimir
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.print();
        
        // Eliminar el iframe después de imprimir
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 100);
      }, 250);
    };
  }, [model?.data?.Rows, tableHeader, section])

  // END METHODS

  // UI METHODS

  useEffect(() => {
    console.log("entro", new Date())
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      bindDataRemote();
    }
  }, [sortBy, sortByOrder])

  // useEffect para detectar cambios en filterValues y hacer fetch automático
  useEffect(() => {
    // Solo ejecutar si hay filtros y no están cargando
    if (!loadingFilters && filters.length > 0 && Object.keys(filterValues).length > 0) {
      console.log("🔄 Cambio en filterValues detectado, haciendo fetch...", filterValues);
      const timeoutId = setTimeout(async () => {
        await bindDataRemote();
        await bindDataCountRemote();
        setShowTable(true); // Mostrar la tabla después de la primera carga
      }, 300); // Debounce de 300ms para evitar múltiples llamadas
      
      return () => clearTimeout(timeoutId);
    }
  }, [filterValues, loadingFilters])

  const loadGRIDUI = () => {
    // Scroll interno en la tabla para que la paginación quede al final del viewport
    const tableScrollMaxHeight = isSearching
      ? 'calc(100vh - 400px)' // CON filtros: altura limitada, paginación siempre visible
      : `calc(100vh - 270px)`; // Maximizado: scroll interno amplio, paginación fija abajo
    
    const tableOverflowY = isSearching
      ? 'auto' // CON filtros: con scroll interno para mantener paginación visible
      : 'auto'; // Maximizado: con scroll interno
    
    return (
      <>
        {/* Tabla - Solo se muestra después de consultar */}
        {showTable && (
        <Container>
          <Row
          // className="mx-2"
          >

            <div className="crud-table-outer">
              <div
                className="crud-table-scroll"
                style={{
                  maxHeight: tableScrollMaxHeight,
                  minHeight: "auto",
                  overflowY: tableOverflowY,
                  ["--app-sticky-top"]: `0px`,
                  borderRadius: '7px',
                  paddingBottom: '1rem',
                }}
              >
                <Table hover size="xl" bordered className="crud-table border shadow-sm" >
                  <thead className="table-secondary crud-table-thead">
                    <tr>
                      {headerWithoutAuditFields()
                        .map((item, index) => {
                          const isFilterActive = columnFilters[item.FieldName] && columnFilters[item.FieldName].length > 0;
                          const isDropdownOpen = openFilterColumn === item.FieldName;
                          
                          return (
                            <th key={index} className={`fw-bold position-relative crud-table-th`}>
                              <div className="d-flex justify-content-between align-items-center">
                                <span 
                                  className="clickable"
                                  onClick={() => {
                                    setSortBy(item.FieldName);
                                    if (item.FieldName === sortBy) {
                                      if (sortByOrder === 'ASC') {
                                        setSortByOrder('DESC')
                                      } else {
                                        setSortByOrder('ASC')
                                      }
                                    } else {
                                      setSortByOrder('ASC')
                                    }
                                  }}
                                >
                                  {item.FieldTitle} 
                                  {sortBy === item.FieldName && sortByOrder === 'ASC' ? 
                                    <i className="fas fa-sort-up ms-1"></i> : 
                                    sortBy === item.FieldName && sortByOrder === 'DESC' ? 
                                    <i className="fas fa-sort-down ms-1"></i> : null
                                  }
                                </span>
                                
                                {/*
                                
                                <button
                                  className={`btn btn-sm btn-link p-0 ms-2 ${isFilterActive ? 'text-primary' : ''}`}
                                  title={`Filtrar por ${item.FieldTitle}`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleFilterDropdown(item.FieldName);
                                  }}
                                >
                                
                                  <i className={`fa-solid ${isFilterActive ? 'fa-filter-circle-xmark' : 'fa-filter'}`}></i>
                                  
                                </button>
                                */}
                                
                              </div>
                              
                              {isDropdownOpen && (
                                <div 
                                  className="position-absolute bg-white border rounded shadow-lg p-3" 
                                  style={{
                                    top: '100%',
                                    left: 0,
                                    zIndex: 1050,
                                    minWidth: '250px',
                                    marginTop: '5px'
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="mb-2">
                                    <label className="form-label small fw-bold">Filtrar por {item.FieldTitle}</label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder={`Buscar ${item.FieldTitle}...`}
                                      value={columnFilters[item.FieldName] || ""}
                                      onChange={(e) => updateColumnFilter(item.FieldName, e.target.value)}
                                      onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                          applyColumnFilter();
                                        }
                                      }}
                                      autoFocus
                                    />
                                  </div>
                                  <div className="d-flex justify-content-end gap-2">
                                    <button
                                      className="btn btn-sm btn-outline-secondary"
                                      onClick={async () => {
                                        setSearch("");
                                        setColumnFilters({});
                                        setOpenFilterColumn(null);
                                        await bindDataRemote(true);
                                        await bindDataCountRemote(true);
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#364054';
                                        e.currentTarget.style.borderColor = '#364054';
                                        e.currentTarget.style.color = '#fff';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '';
                                        e.currentTarget.style.borderColor = '';
                                        e.currentTarget.style.color = '';
                                      }}
                                    >
                                      Limpiar
                                    </button>
                                    <button
                                      className="btn btn-sm btn-primary"
                                      onClick={applyColumnFilter}
                                    >
                                      Aplicar
                                    </button>
                                  </div>
                                </div>
                              )}
                            </th>
                          )
                        })}
                    </tr>
                  </thead>
                  <tbody>
                    {model?.data && model.data.Rows.map((item, index) => {

                  // console.log("item", item, "header", tableHeader);
                  return (
                    <tr key={index} onClick={() => { setSelectedItem(item) }} className={selectedItem && selectedItem.GUID === item.GUID ? "active" : ""}>
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} className={` `}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          // Detectar si la columna contiene iconos en formato JSON
                          const cellValue = item[column.FieldName];
                          let parsedIcons = null;
                          
                          // Intentar parsear si es un string que parece JSON de iconos
                          if (typeof cellValue === 'string' && cellValue.trim().startsWith('[')) {
                            try {
                              parsedIcons = JSON.parse(cellValue);
                            } catch (e) {
                              console.warn(`⚠️ No se pudo parsear JSON en columna ${column.FieldName}:`, cellValue, e);
                            }
                          }
                          
                          // Si logramos parsear un array de iconos estructurados
                          if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                            console.log(`🎨 Renderizando ${parsedIcons.length} iconos para ${column.FieldName}`);
                            return (
                              <td key={index2} style={{ textAlign: 'center' }}>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                  {parsedIcons.map((iconObj, iconIdx) => {
                                    const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                                    const iconClass = iconObj.icon;
                                    const isEditarIcon = iconObj.function === 'Editar' || iconObj.Name === 'Editar';
                                    const isEliminarIcon = iconObj.function === 'Eliminar' || iconObj.Name === 'Eliminar';
                                    const isVisualizarIcon = iconObj.function === 'Visualizar' || iconObj.Name === 'Visualizar';
                                    const isImprimirIcon = iconObj.function === 'Imprimir' || iconObj.Name === 'Imprimir';
                                    
                                    return (
                                      <button
                                        key={iconIdx}
                                        className={`btn btn-sm`}
                                        title={iconObj.Name || iconObj.function}
                                        disabled={isDisabled || loading}
                                        onClick={async (e) => {
                                          e.stopPropagation(); // Evitar que se seleccione la fila
                                          
                                          // Establecer el item actual como seleccionado
                                          setSelectedItem(item);
                                          
                                          // Ejecutar la acción correspondiente pasando el item directamente
                                          if (isEditarIcon) {
                                            await toggleOpen("U", false, item);
                                          } else if (isEliminarIcon) {
                                            // Para eliminar también necesitamos el item
                                            deleteConfirm();
                                          } else if (isVisualizarIcon) {
                                            await toggleOpen("C", false, item);
                                          } else if (isImprimirIcon) {
                                            // Ejecutar impresión y abrir PDF
                                            await handlePrintReport(item);
                                          }
                                        }}
                                        style={{
                                          opacity: isDisabled ? 0.5 : 1,
                                          cursor: isDisabled ? 'not-allowed' : 'pointer',
                                          padding: '0.25rem 0.5rem',
                                          border: 'none',
                                          background: 'transparent'
                                        }}
                                      >
                                        <i className={iconClass} style={{ fontSize: '1.2rem' }}></i>
                                      </button>
                                    );
                                  })}
                                </div>
                              </td>
                            );
                          }

                          return (
                            <td key={index2} className={` `}>{
                              (typeof item[column.FieldName] === 'boolean') ? <input type="checkbox" checked={item[column.FieldName]} className="" readOnly /> : item[column.FieldName]
                            }</td>
                          )
                        })}
                    </tr>
                  )
                    })}
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<div className="d-flex align-items-center gap-3">
                <p className="m-0 fw-bold">Total de registros:</p>
                <span 
                  className="badge d-flex align-items-center justify-content-center" 
                  style={{ 
                    fontSize: '0.875rem', 
                    height: '25px',
                    minWidth: '70px',
                    padding: '0.25rem 0.5rem', 
                    backgroundColor: '#ffffff', 
                    color: '#495057',
                    border: '1px solid #DFE2E6' 
                  }}
                >
                  {recordCount.toLocaleString('en-US')}
                </span>
                <p className="m-0">Registros por página:</p>
                <div>
                  <select
                      className="form-select form-select-sm"
                      value={allowedPageSizes.find(item => item.value === RecordsQuantity)}
                      onChange={(e) => {
                        console.log("selected value", e.target.value)
                        if (e.target.value < 1) {
                          setRecordsQuantity(recordCount);
                        } else {
                          setRecordsQuantity(e.target.value)
                        }
                        setCurrentPage(1)
                      }}
                    >
                      {allowedPageSizes.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.text}
                          </option>
                        );
                      }
                      )}
                    </select>
                </div>
              </div>)}
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<Pagination className="my-0">
                <Pagination.First disabled={loading} onClick={() => setCurrentPage(1)} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 || loading} />
                
                {/* Lógica de paginación dinámica - Muestra 5 páginas */}
                {(() => {
                  const pages = [];
                  let startPage, endPage;
                  
                  if (totalPages <= 5) {
                    // Si hay 5 páginas o menos, mostrar todas
                    startPage = 1;
                    endPage = totalPages;
                  } else {
                    // Si hay más de 5 páginas
                    if (currentPage <= 3) {
                      // Al inicio: mostrar 1, 2, 3, 4, 5
                      startPage = 1;
                      endPage = 5;
                    } else if (currentPage >= totalPages - 2) {
                      // Al final: mostrar las últimas 5
                      startPage = totalPages - 4;
                      endPage = totalPages;
                    } else {
                      // En el medio: mostrar 2 antes y 2 después de la actual
                      startPage = currentPage - 2;
                      endPage = currentPage + 2;
                    }
                  }
                  
                  // Mostrar ellipsis al inicio si es necesario
                  if (startPage > 1) {
                    pages.push(
                      <Pagination.Item 
                        key={1}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </Pagination.Item>
                    );
                    if (startPage > 2) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
                    }
                  }
                  
                  // Mostrar las páginas del rango
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <Pagination.Item 
                        key={i}
                        disabled={loading} 
                        active={currentPage === i}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }
                  
                  // Mostrar ellipsis al final si es necesario
                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
                    }
                    pages.push(
                      <Pagination.Item 
                        key={totalPages}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  }
                  
                  return pages;
                })()}
                
                <Pagination.Next disabled={currentPage >= totalPages || loading} onClick={() => setCurrentPage(currentPage + 1)} />
                <Pagination.Last disabled={loading} onClick={() => setCurrentPage(totalPages)} />
              </Pagination>)}
            </div>
            {/* {console.log("Current Page", currentPage, "Total Pages", totalPages)} */}
          </Row>
        </Container>
        )}

        {/* Add by Victor: Agrega la maquetacion del formato en PDF */}
        <Container id="contentContainer" style={{ 
            position: 'absolute', 
            left: '-9999px', 
            top: 0,
            width: '100%' // Ancho fijo para el PDF
          }}>
          <div className="mb-4 text-center">
            <img src={logoSignos} alt="Signos Framework" width={400} />
            <h3 className="fw-bold">Signos Framework SRL</h3>
            <p>Ave. Rómulo Betancourt, Esq. Dr. Fernando A. Defilló, No. 1428 · Sector Bella Vista · Santo Domingo, República Dominicana.</p>
            <p>RNC: 1234567890</p>
            <p>Fecha: {moment().format("DD/MM/YYYY")}</p>
          </div>
          <Row className="mx-2">
            <h4 className="text-center fw-bold">{section.FormTitle}</h4>

            <Table hover size="xl" bordered className="border shadow-sm" >
              <thead className="table-secondary">
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      return (
                        <th key={index} className={`fw-bold`}>
                          {item.FieldTitle}
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr key={index}>
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          return (
                            <td key={index2}>
                              {(typeof item[column.FieldName] === 'boolean') ? 
                                (item[column.FieldName] ? 'Sí' : 'No') : 
                                item[column.FieldName]
                              }
                            </td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Row>
        </Container>
      </>
    );
  };

  //EVENTS


  useEffect(() => {
    setOpen(false)
    setSelectedItem(null)
    setActionMode(null)
    setGeneralError(null)
    setModel(initialModel);
    checkIfPinned();
    setSearch("");
    setColumnFilters({});
    setShowTable(false); // Ocultar tabla hasta que se carguen los filtros y datos
    setLoadingFilters(true); // Iniciar carga de filtros
    bindDataModelRemote();
    bindDataHeaderRemote(); // Esto cargará los filtros y inicializará filterValues
    setCurrentPage(1);
    // bindDataRemote() se ejecutará automáticamente cuando filterValues se actualice

    return () => formik.resetForm();
  }, [params.id]);

  useEffect(() => {

    console.log("section updated", model)
    prepareFormikObject();
  }, [section, fields]);
  // END EVENTS
  useEffect(() => {
    console.log("entro record quantity")
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      bindDataRemote();
    }
  }, [RecordsQuantity])

  useEffect(() => {
    console.log("Record Count", recordCount, "Records Quantity", RecordsQuantity);
    console.log("Pages", Math.ceil(recordCount / RecordsQuantity))
    setTotalPages(Math.ceil(recordCount / RecordsQuantity))
  }, [recordCount, RecordsQuantity])
  
  // Limpiar URLs de preview cuando el componente se desmonte (solo locales)
  useEffect(() => {
    return () => {
      selectedFiles.forEach(fileData => {
        if (fileData.previewUrl && !fileData.isExisting) {
          URL.revokeObjectURL(fileData.previewUrl);
        }
      });
    };
  }, [selectedFiles])

  // Control de teclado para el visor de archivos
  useEffect(() => {
    if (!viewerOpen) return;
    
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') {
        closeFileViewer();
      } else if (e.key === 'ArrowLeft') {
        goToPreviousFile();
      } else if (e.key === 'ArrowRight') {
        goToNextFile();
      }
    };
    
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [viewerOpen, selectedFiles.length])
  
  // Calcular la altura del header sticky para ajustar el top del thead
  useEffect(() => {
    const node = stickyHeaderRef.current;

    if (!node) {
      setStickyHeaderHeight(0);
      return;
    }

    const updateStickyHeight = () => {
      const height = node.offsetHeight || 0;
      setStickyHeaderHeight(height);
      console.log("📏 Altura del header sticky (Transaction):", height);
    };
    
    updateStickyHeight();

    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateStickyHeight)
      : null;

    if (observer) {
      observer.observe(node);
    }
    
    window.addEventListener('resize', updateStickyHeight);
    
    return () => {
      if (observer) {
        observer.disconnect();
      }
      window.removeEventListener('resize', updateStickyHeight);
    };
  }, [open, actionMode, loading, section, tableHeader, model?.data?.Rows?.length]);
  
  // Renderizar ErrorModal incluso si section es null
  if (!section) {
    return <ErrorModal />
  }
  
  return (
    <React.Fragment>
      <style>{`
        .file-preview:hover .file-preview-icon {
          opacity: 1 !important;
        }
        /* Campos que deben mostrar texto en mayúsculas instantáneamente */
        input[name="Descripcion"],
        textarea[name="Descripcion"],
        input[name="Comentario"],
        textarea[name="Comentario"],
        .dx-texteditor-input[name="Descripcion"],
        .dx-texteditor-input[name="Comentario"] {
          text-transform: uppercase !important;
        }
      `}</style>
      {open ?
        <Modal
          show={open}
          onHide={() => {
            // Limpiar URLs de preview (solo los locales)
            selectedFiles.forEach(fileData => {
              if (fileData.previewUrl && !fileData.isExisting) {
                URL.revokeObjectURL(fileData.previewUrl);
              }
            });
            setSelectedFiles([]); // Limpiar archivos
            toggleOpen(null);
          }}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-fullwidth-custom"
          className="modalRight"
        
        >
          <Modal.Header style={{ backgroundColor: "#D7DEE5" }}>
            <Modal.Title>{section.FormTitle}</Modal.Title>
            <CustomCloseButton onClose={() => {
              // Limpiar URLs de preview (solo los locales)
              selectedFiles.forEach(fileData => {
                if (fileData.previewUrl && !fileData.isExisting) {
                  URL.revokeObjectURL(fileData.previewUrl);
                }
              });
              setSelectedFiles([]); // Limpiar archivos
              toggleOpen(null);
            }} />
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Row>
                {/* CONTENT */}

                <label className="me-2 separatorTitle">Datos de la novedad</label>
                <hr className="separatorLine" />
                
                {
                  fields.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Col
                          className={
                            item.cssClasss + (!item.Visible ? " d-none" : "")
                          }
                          key={index}
                        >
                          <label className={item.HtmlType === 'separator' ? `me-2 ${(index !== 0 ? "mt-4 pt-4" : "mt-2")}  separatorTitle` : "me-2 mt-3 "}>{item.FieldTitle}
                            {item.Required ? <i className="required-asterisk ms-1 text-danger">*</i> : null}
                          </label>
                          <br />

                          <FieldSelector
                            actionMode={actionMode}
                            model={item}
                            key={index}
                            obj={formik.values}
                            // limit longitudes
                            updateField={updateField}
                            value={formik.values[item.FieldName]}
                          ></FieldSelector>
                          {formik.errors[item.FieldName] ? (
                            <div className="invalid text-sm">
                              {formik.errors[item.FieldName]}
                            </div>
                          ) : null}
                        </Col>
                      </React.Fragment>
                    );
                  })}
              </Row>

              {/* Modified by Frandy para mostrar los errores de los campos */}

               {/*
              
                {Object.values(formik.errors).length > 0 && Object.values(formik.errors).map(item => {

                  return <Row className="invalid me-2 ">{item}</Row>
                })}
            
              */}

              {/* Sección de subida de archivos */}
              {(actionMode === "I" || actionMode === "U" || actionMode === "C") && (
                <Row className="mt-4">
                  <Col md={12}>
                    <label className="me-2 separatorTitle">📎 Archivos Adjuntos</label>
                    <hr className="separatorLine" />
                    
                    {actionMode !== "C" && (
                      <div className="mb-3">
                        <input
                          type="file"
                          multiple
                          accept="image/*,.pdf,video/*"
                          id="fileInput"
                          style={{ display: 'none' }}
                          onChange={(e) => {
                          const files = Array.from(e.target.files);
                          
                          // Validar que solo sean imágenes, PDF o videos
                          const validFiles = files.filter(file => {
                            const isImage = file.type.startsWith('image/');
                            const isPDF = file.type === 'application/pdf';
                            const isVideo = file.type.startsWith('video/');
                            return isImage || isPDF || isVideo;
                          });
                          
                          if (validFiles.length !== files.length) {
                            toast({
                              type: "warning",
                              message: "Solo se permiten archivos de imagen, PDF o video"
                            });
                          }
                          
                          const newFiles = validFiles.map(file => {
                            const isImage = file.type.startsWith('image/');
                            const isVideo = file.type.startsWith('video/');
                            const isPDF = file.type === 'application/pdf';
                            const previewUrl = (isImage || isVideo || isPDF) ? URL.createObjectURL(file) : null;
                            
                            return {
                              file,
                              comentario: '',
                              id: Date.now() + Math.random(),
                              previewUrl,
                              isImage,
                              isVideo,
                              isPDF
                            };
                          });
                          
                          setSelectedFiles([...selectedFiles, ...newFiles]);
                          e.target.value = ''; // Reset input
                        }}
                      />
                      
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => document.getElementById('fileInput').click()}
                        disabled={loading || uploadingFiles}
                      >
                        <i className="fa fa-paperclip me-2"></i>
                        Seleccionar Archivos (Imágenes, PDF, Videos)
                      </button>
                      
                      {selectedFiles.length > 0 && (
                        <span className="ms-3 text-muted">
                          {selectedFiles.length} archivo(s) total
                          {selectedFiles.filter(f => f.isExisting && !f.isReplacing).length > 0 && 
                            ` (${selectedFiles.filter(f => f.isExisting && !f.isReplacing).length} existente(s), ${selectedFiles.filter(f => !f.isExisting).length} nuevo(s)${selectedFiles.filter(f => f.isReplacing).length > 0 ? `, ${selectedFiles.filter(f => f.isReplacing).length} a reemplazar` : ''})`
                          }
                        </span>
                      )}
                      </div>
                    )}
                    
                    {/* Lista de archivos seleccionados en grid de 3 columnas */}
                    {selectedFiles.length > 0 && (
                      <Row className="border rounded p-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                        {selectedFiles.map((fileData, index) => (
                          <Col md={4} key={fileData.id} className="mb-4">
                            <div className="border rounded p-2 h-100 d-flex flex-column">
                              {/* Preview de imagen, video o PDF */}
                              <div 
                                className="mb-2 d-flex align-items-center justify-content-center bg-light rounded file-preview" 
                                style={{ 
                                  height: '180px', 
                                  position: 'relative', 
                                  overflow: 'hidden',
                                  cursor: 'pointer',
                                  transition: 'transform 0.2s, box-shadow 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'scale(1.02)';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                }}
                                onClick={(e) => {
                                  // No abrir el visor si se hizo clic en un botón
                                  // o en un elemento marcado explícitamente para NO abrir el preview
                                  const isButtonClick =
                                    e.target.tagName === 'BUTTON' || e.target.closest('button');
                                  const isNoPreviewElement =
                                    e.target.getAttribute('data-no-preview') === 'true' ||
                                    e.target.closest('[data-no-preview="true"]');

                                  if (isButtonClick || isNoPreviewElement) {
                                    e.stopPropagation();
                                    return;
                                  }

                                  openFileViewer(index);
                                }}
                              >
                                {fileData.isImage ? (
                                  <img 
                                    src={fileData.previewUrl} 
                                    alt={fileData.file.name}
                                    style={{ 
                                      maxWidth: '100%', 
                                      maxHeight: '100%', 
                                      objectFit: 'contain' 
                                    }}
                                  />
                                ) : fileData.isVideo ? (
                                  <video 
                                    src={fileData.previewUrl}
                                    controls
                                    style={{ 
                                      maxWidth: '100%', 
                                      maxHeight: '100%', 
                                      objectFit: 'contain' 
                                    }}
                                  />
                                ) : fileData.isPDF ? (
                                  <div className="text-center">
                                    <i className="fa fa-file-pdf fa-4x text-danger mb-2"></i>
                                    <div className="small text-muted">PDF</div>
                                  </div>
                                ) : (
                                  <div className="text-center">
                                    <i className="fa fa-file fa-4x text-secondary mb-2"></i>
                                    <div className="small text-muted">Archivo</div>
                                  </div>
                                )}
                                
                                {/* Ícono de ver en pantalla completa */}
                                <div 
                                  className="position-absolute file-preview-icon"
                                  style={{ 
                                    top: '50%', 
                                    left: '50%', 
                                    transform: 'translate(-50%, -50%)',
                                    opacity: 0,
                                    transition: 'opacity 0.2s',
                                    pointerEvents: 'none',
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                    borderRadius: '50%',
                                    width: '60px',
                                    height: '60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <i className="fa fa-search-plus fa-2x text-white"></i>
                                </div>
                                
                                {/* Input oculto para reemplazar archivo */}
                                {fileData.isExisting && actionMode === "U" && (
                                  <input
                                    type="file"
                                    accept="image/*,.pdf,video/*"
                                    id={`replaceFileInput-${index}`}
                                    data-no-preview="true"
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                      const newFile = e.target.files[0];
                                      if (newFile) {
                                        // Validar tipo de archivo
                                        const isImage = newFile.type.startsWith('image/');
                                        const isPDF = newFile.type === 'application/pdf';
                                        const isVideo = newFile.type.startsWith('video/');
                                        
                                        if (!isImage && !isPDF && !isVideo) {
                                          toast({
                                            type: "warning",
                                            message: "Solo se permiten archivos de imagen, PDF o video"
                                          });
                                          return;
                                        }
                                        
                                        // Crear preview del nuevo archivo
                                        const previewUrl = (isImage || isVideo) ? URL.createObjectURL(newFile) : null;
                                        
                                        // Actualizar el archivo marcándolo para reemplazo
                                        const updatedFiles = [...selectedFiles];
                                        
                                        // Liberar la URL anterior si existe
                                        if (updatedFiles[index].previewUrl && updatedFiles[index].isReplacing) {
                                          URL.revokeObjectURL(updatedFiles[index].previewUrl);
                                        }
                                        
                                        updatedFiles[index] = {
                                          ...updatedFiles[index],
                                          newFile: newFile, // Guardar el nuevo archivo
                                          originalFileName: updatedFiles[index].file.name, // Mantener nombre original
                                          file: {
                                            ...updatedFiles[index].file,
                                            name: newFile.name,
                                            size: newFile.size
                                          },
                                          previewUrl: previewUrl || updatedFiles[index].previewUrl,
                                          isImage,
                                          isPDF,
                                          isVideo,
                                          isReplacing: true, // Marcar como archivo para reemplazar
                                        };
                                        
                                        setSelectedFiles(updatedFiles);
                                        e.target.value = ''; // Reset input
                                        
                                        toast({
                                          type: "info",
                                          message: `Archivo seleccionado para reemplazar: ${newFile.name}`
                                        });
                                      }
                                    }}
                                  />
                                )}
                                
                                {/* Botón reemplazar al lado del botón eliminar - Solo visible para archivos existentes en modo U */}
                                {fileData.isExisting && actionMode === "U" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary position-absolute"
                                    style={{ top: '5px', right: '45px', zIndex: 100, pointerEvents: 'auto' }}
                                    data-no-preview="true"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      document.getElementById(`replaceFileInput-${index}`).click();
                                    }}
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                    }}
                                    disabled={loading || uploadingFiles}
                                    title="Reemplazar archivo"
                                  >
                                    <i className="fa fa-pen-to-square" style={{ pointerEvents: 'none' }}></i>
                                  </button>
                                )}
                                
                                {/* Botón eliminar en esquina superior derecha - Solo visible en modos I y U */}
                                {actionMode !== "C" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger position-absolute"
                                    style={{ top: '5px', right: '5px', zIndex: 20, pointerEvents: 'auto' }}
                                    data-no-preview="true"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      
                                      console.log("🗑️ Click en eliminar archivo:", {
                                        index,
                                        fileName: fileData.file.name,
                                        isExisting: fileData.isExisting,
                                        currentPendingDelete: fileData.pendingDelete
                                      });
                                      
                                      // Mostrar confirmAlert con el mismo estilo que el guardado
                                      const mensajeConfirmacion = fileData.isExisting 
                                        ? "¿Confirma que desea eliminar este archivo?"
                                        : "¿Confirma que desea eliminar este archivo?";
                                      
                                      confirmAlert({
                                        closeOnClickOutside: false,
                                        customUI: ({ onClose }) => {
                                          return (
                                            <CustomModal
                                              type="error"
                                              title="¡Confirmar Acción!"
                                              message={mensajeConfirmacion}
                                              icon="fa-trash-can"
                                              primaryButtonText="Continuar"
                                              secondaryButtonText="Cancelar"
                                              onPrimaryClick={async () => {
                                                console.log("🗑️ Confirmando eliminación de archivo:", {
                                                  index,
                                                  fileName: fileData.file.name,
                                                  isExisting: fileData.isExisting
                                                });
                                                
                                                // Si es un archivo existente, ejecutar el endpoint DELETE inmediatamente
                                                if (fileData.isExisting) {
                                                      try {
                                                        // Obtener ID y GUID del registro actual
                                                        const idNovedad = selectedItem?.Id || formik.values.Id;
                                                        const guidNovedad = selectedItem?.GUID || formik.values.GUID;
                                                        
                                                        console.log("🗑️ Eliminando archivo del servidor:", {
                                                          idNovedad,
                                                          guidNovedad,
                                                          documentId: fileData.documentId,
                                                          fileName: fileData.originalFileName
                                                        });
                                                        
                                                        // Crear FormData para el DELETE
                                                        const formData = new FormData();
                                                        formData.append('Token', user.Token);
                                                        formData.append('IdUser', user.IdUser);
                                                        formData.append('IdNovedad', idNovedad);
                                                        formData.append('id', fileData.documentId);
                                                        formData.append('GUIDNovedad', guidNovedad);
                                                        formData.append('Documento', fileData.originalFileName);
                                                        
                                                        // Ejecutar DELETE
                                                        const response = await AxiosInstance.request({
                                                          method: 'DELETE',
                                                          url: 'api/OcupacionProcesos/NovedadesDocumentosFilesDel',
                                                          data: formData,
                                                          headers: {
                                                            'Content-Type': 'multipart/form-data'
                                                          }
                                                        });
                                                        
                                                        console.log("✅ Archivo eliminado del servidor:", response.data);
                                                        
                                                        // Eliminar del array
                                                        setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
                                                        
                                                        showSuccessModal(`Archivo "${fileData.file.name}" eliminado correctamente!`);
                                                      } catch (error) {
                                                        console.error("❌ Error al eliminar archivo del servidor:", error);
                                                        toast({
                                                          type: "error",
                                                          message: `Error al eliminar el archivo "${fileData.file.name}". ${error.message || ''}`
                                                        });
                                                      }
                                                    } else {
                                                      // Archivo nuevo: simplemente eliminarlo del array
                                                      // Liberar URL del preview si es local
                                                      if (fileData.previewUrl && (!fileData.isExisting || fileData.isReplacing)) {
                                                        URL.revokeObjectURL(fileData.previewUrl);
                                                      }
                                                      console.log("🗑️ Eliminando archivo nuevo del array");
                                                      setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
                                                      showSuccessModal(`Archivo "${fileData.file.name}" eliminado.`);
                                                    }
                                                  }}
                                                  onSecondaryClick={() => {
                                                    console.log("🗑️ Eliminación cancelada por el usuario");
                                                  }}
                                                  onClose={onClose}
                                                />
                                          );
                                        }
                                      });
                                    }}
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                    }}
                                    disabled={loading || uploadingFiles}
                                    title="Eliminar archivo"
                                  >
                                    <i className="fa-regular fa-trash-can" style={{ pointerEvents: 'none' }}></i>
                                  </button>
                                )}
                              </div>
                              
                              {/* Nombre y tamaño del archivo - Solo visible en modos I y U */}
                              {actionMode !== "C" && (
                                <div className="mb-2">
                                  <div className="small fw-bold text-truncate" title={fileData.file.name}>
                                    <i className={`fa ${
                                      fileData.isImage ? 'fa-image' : 
                                      fileData.isVideo ? 'fa-video' : 
                                      'fa-file-pdf'
                                    } me-1`}></i>
                                    {fileData.file.name}
                                    {fileData.isReplacing && (
                                      <span className="badge bg-warning text-dark ms-2" style={{ fontSize: '0.65rem' }}>
                                        Se reemplazará
                                      </span>
                                    )}
                                  </div>
                                  <div className="small text-muted">
                                    {fileData.file.size > 0 ? `${(fileData.file.size / 1024).toFixed(2)} KB` : 'Archivo del servidor'}
                                  </div>
                                </div>
                              )}
                              
                              {/* Comentario */}
                              <div className="flex-grow-1">
                                <Form.Control
                                  as="textarea"
                                  placeholder={fileData.isExisting && actionMode === "C" ? "Comentario (solo lectura)" : "Comentario para este archivo (opcional)"}
                                  value={fileData.comentario}
                                  onChange={(e) => {
                                    const updatedFiles = [...selectedFiles];
                                    updatedFiles[index].comentario = e.target.value.toUpperCase();
                                    setSelectedFiles(updatedFiles);
                                  }}
                                  disabled={loading || uploadingFiles || (actionMode === "C" && fileData.isExisting)}
                                  readOnly={actionMode === "C" && fileData.isExisting}
                                  rows={5}
                                  style={{ 
                                    width: "100%", 
                                    minHeight: "90px", 
                                    resize: "vertical", 
                                    fontSize: '0.85rem',
                                    backgroundColor: (actionMode === "C" && fileData.isExisting) ? '#f8f9fa' : 'white',
                                    textTransform: 'uppercase'
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    )}
                  </Col>
                </Row>
              )}


            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#D7DEE5" }}>
              <div className="d-flex gx-3 align-items-center justify-content-end">
                {/* Mensajes de error y estado */}
                {Object.values(formik.errors).length > 0 && (
                  <span className="invalid me-2">
                    Por favor, verificar los errores en el formulario
                  </span>
                )}

                {generalError ? (
                  <span className="invalid me-2">{generalError}</span>
                ) : null}

                
                {actionMode === "C" ? (
                  // VISTA DE CONSULTA: Botón de Cerrar con tema Azul
                  <div className="altTheme">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => {
                      setSelectedFiles([]);
                      toggleOpen(null);
                    }}
                    style={{ width: "155px", height: "40px" }}
                  >
                    <i className="fa-thin fa-arrow-u-turn-up-left me-2"></i>
                    Cerrar
                  </button>
                  </div>
                ) : (
                  // VISTA DE EDICIÓN/CREACIÓN: Botones Rojo (Cancelar) y Verde (Guardar)
                  <>
                    <button
                      className="btn btn-cancel-hover"
                      type="button"
                      onClick={() => {
                        selectedFiles.forEach((fileData) => {
                          if (fileData.previewUrl && !fileData.isExisting) {
                            URL.revokeObjectURL(fileData.previewUrl);
                          }
                        });
                        setSelectedFiles([]);
                        toggleOpen(null);
                      }}
                      disabled={loading || uploadingFiles}
                    >
                      <i className="fa-thin fa-arrow-u-turn-up-left me-2"></i>
                      Cancelar
                    </button>

                    <button
                      className="btn btn-success ms-2"
                      type="button"
                      onClick={() => formik.submitForm()}
                      disabled={loading || uploadingFiles}
                    >
                      <i className="fa-thin fa-check me-2"></i>
                      {loading || uploadingFiles ? (
                        uploadingFiles ? 'Subiendo...' : 'Guardando...'
                      ) : (
                        'Guardar'
                      )}
                    </button>
                  </>
                )}
              </div>
            </Modal.Footer>
          </Form>
        </Modal> : null}
      
      {/* Modal Visor de Archivos en Pantalla Completa */}
      {viewerOpen && selectedFiles.length > 0 && (
        <Modal
          show={viewerOpen}
          onHide={closeFileViewer}
          size="xl"
          fullscreen={true}
          centered
          className="file-viewer-modal"
        >
          <Modal.Header style={{ backgroundColor: '#D7DEE5', border: 'none' }}>
            <Modal.Title>
              {selectedFiles[currentFileIndex]?.file.name}
            </Modal.Title>
            <CustomCloseButton onClose={closeFileViewer} />
          </Modal.Header>
          <Modal.Body style={{ 
            backgroundColor: '#000', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            position: 'relative',
            padding: '20px'
          }}>
            {/* Contenido del archivo */}
            <div style={{ 
              width: selectedFiles[currentFileIndex]?.isPDF ? '95%' : 'auto',
              maxWidth: selectedFiles[currentFileIndex]?.isPDF ? '95%' : '100%', 
              maxHeight: '100%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center' 
            }}>
              {selectedFiles[currentFileIndex]?.isImage && (
                <img 
                  src={selectedFiles[currentFileIndex].previewUrl} 
                  alt={selectedFiles[currentFileIndex].file.name}
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: 'calc(100vh - 150px)', 
                    objectFit: 'contain' 
                  }}
                />
              )}
              
              {selectedFiles[currentFileIndex]?.isVideo && (
                <video 
                  src={selectedFiles[currentFileIndex].previewUrl}
                  controls
                  autoPlay
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: 'calc(100vh - 150px)', 
                    objectFit: 'contain' 
                  }}
                />
              )}
              
              {selectedFiles[currentFileIndex]?.isPDF && (
                <iframe
                  src={selectedFiles[currentFileIndex].previewUrl}
                  style={{ 
                    width: '100%', 
                    height: 'calc(100vh - 150px)',
                    border: 'none',
                    minWidth: '100%'
                  }}
                  title={selectedFiles[currentFileIndex].file.name}
                />
              )}
            </div>
            
            {/* Flechas de navegación */}
            {selectedFiles.length > 1 && (
              <>
                <button
                  className="btn btn-light position-absolute"
                  style={{ 
                    left: '20px', 
                    top: '50%', 
                    transform: 'translateY(-50%)',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    transition: 'all 0.2s ease',
                    border: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  }}
                  onClick={goToPreviousFile}
                  title="Anterior"
                >
                  <i className="fa fa-chevron-left fa-lg"></i>
                </button>
                
                <button
                  className="btn btn-light position-absolute"
                  style={{ 
                    right: '20px', 
                    top: '50%', 
                    transform: 'translateY(-50%)',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    border: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  }}
                  onClick={goToNextFile}
                  title="Siguiente"
                >
                  <i className="fa fa-chevron-right fa-lg"></i>
                </button>
              </>
            )}
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: '#D7DEE5', border: 'none' }}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              {selectedFiles[currentFileIndex]?.comentario && (
                <div style={{ fontSize: '1rem', marginTop: '8px' }}>
                  {selectedFiles[currentFileIndex].comentario}
                </div>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      )}
      
      <div 
        ref={stickyHeaderRef}
        style={{
          position: 'sticky',
          top: '0px',
          backgroundColor: '#F2F2F2',
          zIndex: open ? 1 : 200,
          paddingBottom: '10px',
        }}
      >
        <Container>
          {section?.FormPath && <Breadcrumbs pathTitle={section?.FormPath} />}
          
          {/* DIV 1: BLOQUE DEL TÍTULO */}
          <div className="row mx-0">
            <div className="col-12">
              <div className="d-flex flex-wrap align-items-center justify-content-between" style={{ marginBottom: isSearching ? "12px" : "0" }}>

                <React.Fragment>
                  <div className="d-flex align-items-center my-1">
                    <i className={section.FormIcon + " me-3 fa-2x"}></i>
                    <div className="d-flex flex-column">
                      <h5 className={"my-1"}>{section.FormTitle}

                      </h5>
                    </div>
                  </div>
                </React.Fragment>
              {loading ? (
                <React.Fragment>
                  <div className="">
                    <div className="w-25 mx-auto my-1" style={{ paddingTop: "" }}>
                      <div className="" role="status" style={{ border: 'none' }}>
                        <span className="visually-hidden">Cargando...</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
              <div className="w-auto d-flex align-items-center">

                {actionMode === null ? (
                  <>
                    <button className="btn btn-sm btn-primary my-1 me-2" title="Crear" disabled={loading} onClick={() => toggleOpen("I")}>
                      <i className="fa fa-plus"></i>
                    </button>
                    <button 
                      className="btn btn-sm my-1 me-2"
                      title="Actualizar" 
                      disabled={loading} 
                      onClick={async () => {
                        await bindDataRemote();
                        await bindDataCountRemote();
                      }}
                      style={{
                        backgroundColor: '#6c757d',
                        borderColor: '#6c757d',
                        color: '#fff'
                      }}
                    >
                      <i className="fa fa-sync"></i>
                    </button>
                  </>
                ) : null}

                {/* Botón de maximizar cuando los filtros están ocultos */}
                {showTable && !isSearching && (
                  <button
                    className="btn btn-sm rounded"
                    onClick={() => setIsSearching(!isSearching)}
                    style={{
                      border: '1px solid rgba(0, 0, 0, 0.15)',
                      transition: 'all 0.2s ease',
                      fontSize: '16px',
                      backgroundColor: 'transparent',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.08)';
                      e.currentTarget.querySelector('i').style.color = 'rgba(0, 123, 255, 0.9)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.querySelector('i').style.color = 'rgba(0, 0, 0, 0.6)';
                    }}
                    title="Mostrar filtros"
                  >
                    <i
                      className="fa-sharp fa-thin fa-arrow-down-left-and-arrow-up-right-to-center"
                      style={{
                        color: 'rgba(0, 0, 0, 0.6)',
                        transition: 'color 0.2s ease'
                      }}
                    ></i>
                  </button>
                )}

                {/* Botón de maximizar cuando los filtros están visibles */}
                {showTable && isSearching && (
                  <button
                    className="btn btn-sm rounded"
                    onClick={() => setIsSearching(!isSearching)}
                    style={{
                      border: '1px solid rgba(0, 0, 0, 0.15)',
                      transition: 'all 0.2s ease',
                      fontSize: '16px',
                      backgroundColor: 'transparent',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.08)';
                      e.currentTarget.querySelector('i').style.color = 'rgba(0, 123, 255, 0.9)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.querySelector('i').style.color = 'rgba(0, 0, 0, 0.6)';
                    }}
                    title="Maximizar tabla (ocultar filtros)"
                  >
                    <i
                      className="fa-sharp fa-thin fa-arrow-up-right-and-arrow-down-left-from-center"
                      style={{
                        color: 'rgba(0, 0, 0, 0.6)',
                        transition: 'color 0.2s ease'
                      }}
                    ></i>
                  </button>
                )}
            
                <Dropdown>
                  <Dropdown.Toggle variant="button" id="dropdown-basic">
                    <i className="fa fa-ellipsis-v" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {isPinned ? 
                      <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i class="fa-thin fa-bookmark-slash" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Remover de favoritos
                      </Dropdown.Item> : 
                      <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i class="fa-thin fa-bookmark" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Agregar a favoritos
                      </Dropdown.Item>
                    }
                    <Dropdown.Divider />
                    {selectedItem ?
                      <Dropdown.Item onClick={() => { toggleOpen('D') }} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i class="fa-thin fa-clone-plus" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Duplicar
                      </Dropdown.Item> : null
                    }


                    {actionMode === null ?
                      <Dropdown.Item onClick={() => { exportToExcel() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i class="fa-thin fa-file-xls" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Exportar a Excel
                      </Dropdown.Item> : null
                    }
                    
                      <Dropdown.Item
                        onClick={() => { exportToPDF() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i class="fa-thin fa-file-pdf" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Exportar a PDF
                      </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => { handlePrint() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i class="fa-thin fa-print" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Imprimir
                    </Dropdown.Item>

                    <Dropdown.Divider />
                    {selectedItem ?
                      <Dropdown.Item onClick={() => deleteConfirm()} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i class="fa-thin fa-trash-can" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Eliminar
                      </Dropdown.Item> : null
                    }
                  </Dropdown.Menu>
                </Dropdown>

              </div>
            </div>
          </div>
        </div>
        
        {/* DIV 2: BLOQUE DE FILTROS */}
        {isSearching && (
        <div className="row mx-0">
          <div className="col-12">
            {/* Filtros dinámicos con Card y background azul */}
            <Card className="mb-4" style={{ borderRadius: '7px' }}>
              <Card.Body className="formBackground" style={{ borderRadius: '7px' }}>
                <Row>
                  {/* Mensaje de carga de filtros */}
                  {loadingFilters && filters.length === 0 ? (
                    <Col md={12} className="text-center text-muted py-4">
                      Cargando filtros...
                    </Col>
                  ) : (
                    <>
                      {/* Generar solo filtros de tipo date desde el API */}
                      {filters && filters.length > 0 ? (
                        filters
                          .filter(filter => filter.HtmlType === 'date')
                          .map((filter, index) => (
                            <div key={filter.FieldName} className={filter.cssClasss || 'col-12 col-md-6'}>
                              <label className="form-label small fw-bold">
                                {filter.FieldTitle || filter.FieldName}
                                {filter.Required && <span className="text-danger ms-1">*</span>}
                              </label>
                              
                              <DateBox
                                id={filter.FieldName}
                                name={filter.FieldName}
                                placeholder={filter.PlaceHolder || `Seleccione ${filter.FieldTitle}`}
                                displayFormat="dd/MM/yyyy"
                                value={filterValues[filter.FieldName] ? moment(filterValues[filter.FieldName]).isValid() ? moment(filterValues[filter.FieldName]).toDate() : null : null}
                                onValueChanged={(e) => {
                                  const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                                  setFilterValues({
                                    ...filterValues,
                                    [filter.FieldName]: formattedDate
                                  });
                                }}
                              />
                            </div>
                          ))
                      ) : null}
                    </>
                  )}
                </Row>
              </Card.Body>
            </Card>
          </div>
        </div>
        )}
        </Container>
      </div>
      
      <Container>
        {/* DIV 3: BLOQUE DE CONTENIDO */}
        <div className="row mx-0">
          <div className="col-12">
            {loadGRIDUI()}
          </div>
        </div>
      </Container>

      {/* Modal de error de la API */}
      <ErrorModal />
    </React.Fragment>
  );
}
